export default __webpack_public_path__ + "static/media/noun_X_2172405.0e3fa7f4.png";